// Get Lookbook Order Item
export const GET_LOOKBOOK_ORDER_ITEM_REQUEST = 'GET_LOOKBOOK_ORDER_ITEM_REQUEST';
export const GET_LOOKBOOK_ORDER_ITEM_DONE = 'GET_LOOKBOOK_ORDER_ITEM_DONE';
export const GET_LOOKBOOK_ORDER_ITEM_FAILED = 'GET_LOOKBOOK_ORDER_ITEM_FAILED';
